import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import Backdrop from '@mui/material/Backdrop';
import "react-responsive-combo-box/dist/index.css";
import MDTypography from "components/MDTypography";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import Config from "../../config.js";
import {  handleErrors, checkPrivilege } from "common.js";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import CircularProgress from "@mui/material/CircularProgress";
import { PRIVILEGE } from 'constants.js';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ValidationErrorTable from './components/validationErrors.js';
import Button from '@mui/material/Button';

function BulkUpload() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const adminType = localStorage.getItem("type");
    const [errorFlag, setErrorFlag] = useState(false);
    const [responseData, setResponseData] = useState('');
    const [validationErrors,setValidationErrors] =useState([]);

    const { register, handleSubmit, watch, formState: { errors }, setValue, setError, clearErrors, rigger, reset,
    } = useForm({});

    const onSubmit = async (data) => {
      const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };
        setIsLoading(true);

        const base64File = await convertToBase64(data.file[0]);
        axios.post(BASE + 'api/product/upload-product-xlsx-file', {"fileInfo":base64File}, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY
            }
        }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {

                    if (response.data.data.failureCount > 0) {
                        setResponseData(response.data.data);
                        setErrorFlag(true);
                    }
                    else {
                        const count = response.data.data.successCount;
                        toast.success(t("productImportSuccess", { count: count }));
                        const redirectTimeout = setTimeout(() => {
                            clearTimeout(redirectTimeout);
                            navigate(`/products/manage/`);
                        }, 2000);
                    }
                }
                else if (status ==0 && response.data && response.data.validationErrors)
                    {
                        let message = response.data.message;
                        let validationErrors =response.data.validationErrors;
                        toast.error(t(message))
                        setValidationErrors(validationErrors);

                    }
                else if (response && response.data && response.data.errors && response.data.errors.length > 0) {
                        const errorData = response.data.errors;
                        errorData.forEach((error) => {
                            setError(error.field, {
                                type: 'server',
                                message: t(error.errors[0])
                            });
                        });
                    }
                    else
                {
                        toast.error(t(message))
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    };

    const validateFileExtension = (file) => {
        const allowedExtensions = ['xlsx'];
        const fileExtension = file[0].name.split('.').pop();
        return allowedExtensions.includes(fileExtension.toLowerCase());
    };

    const downloadXLS=()=>{
        setIsLoading(true);
        toast.dismiss();
        axios({
            url: BASE + "api/product/download-bulkupload-template",
            method: "GET",
            headers: {
              Authorization: `Bearer ${TOKEN}`,
              function: Config.FUNCTION_KEY
            },
          }).then(function (response) {
            const requestStatus = response.status;
            setIsLoading(false);
            if (requestStatus == 200) {
            const responseData = response.data;
            const status = responseData.status;
            const message = responseData.message;
         

            if (status == 1 && responseData.data) {

                const content =responseData.data.content;
                const fileName =responseData.data.fileName;
                
                const byteCharacters = atob(content);
                const byteArrays = [];
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArrays.push(byteCharacters.charCodeAt(i));
                }
                const byteArray = new Uint8Array(byteArrays);
                const blob = new Blob([byteArray], { type: 'application/octet-stream' });
            
                // Create a download link and trigger the download
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                toast.success(t(message));
            

            }
            else
            {
                toast.error(t(message));
            }
         


            }else{
                toast.error(t('unableToProccessRequest'));
            }

          }).catch((error) => {
            setIsLoading(false);
            handleErrors(error, t, navigate);
          });

    }

    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={t('bulkUpload')} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <MDBox mt={3} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid item xs={12} md={12} lg={12}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {errorFlag ?
                                    <Card>
                                        <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                            {responseData.successCount > 0 ?
                                                <> <Grid item xs={12} sm={12} md={12}>
                                                    <MDTypography variant="h6" className="uppercaseLetters">{t('productImportSuccess', { count: responseData.successCount })}</MDTypography>
                                                </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <MDTypography variant="body1" className="labelStyle">{t('importedProducts')}</MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={8} md={8}>
                                                        <List>
                                                            {responseData.successItems.map((item, index) => (
                                                                <ListItem key={index}>
                                                                    <ListItemText primary={item} />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </Grid></>
                                                : null}
                                            <Grid item xs={12} sm={12} md={12}>
                                                <MDTypography variant="h6" className="uppercaseLetters">{t('productImportFail', { count: responseData.failureCount })}</MDTypography>
                                            </Grid>
                                            <Grid item xs={12} sm={4} md={4}>
                                                <MDTypography variant="body1" className="labelStyle">{t('failedProducts')}</MDTypography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} md={8}>
                                                <List>
                                                    {responseData.failureItems.map((item, index) => (
                                                        <ListItem key={index}>
                                                            <ListItemText primary={item} />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                    :
                                    <Card>
                                        <Grid container spacing={2} alignItems="center" sx={{ p: 3 }}>
                                            
                                        <Grid item xs={12} sm={4} md={4}>
                                                <MDTypography variant="body1" className="labelStyle">{t('downloadTemplate')}
                                                    
                                                </MDTypography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} md={8}>
                                        
 <MDButton type="button" variant="gradient" color="info" disableRipple onClick={downloadXLS} >{t('download')}</MDButton>


                                            </Grid>

                                            <Grid item xs={12} sm={4} md={4}>
                                                <MDTypography variant="body1" className="labelStyle">{t('uploadFile')}
                                                    <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                                </MDTypography>
                                            </Grid>
                                            <Grid item xs={12} sm={8} md={8}>
                                                <MDInput
                                                    type="file"
                                                    name="file"
                                                    InputProps={{
                                                        classes: { root: "inputBoxStyle" },
                                                    }}
                                                    fullWidth
                                                    {...register("file", {
                                                        required: t('fileRequired'),
                                                        validate: (value) => {
                                                            if (!validateFileExtension(value)) {
                                                                return t('invalidFileFormat');
                                                            }
                                                            return true;
                                                        }
                                                    })}
                                                />
                                                <MDTypography component="span" variant="caption" className="importFileNote">{t('importFileFormat')}</MDTypography>
                                                {errors.file && (<span className="errorMsg FloatRight">{errors.file.message}</span>)}
                                            </Grid>
                                            <Grid item xs={12} sm={4} md={4}></Grid>
                                            <Grid item xs={12} sm={8} md={8}>

                                            {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "write"))) ?
                                                        
                                                            <MDButton type="submit" variant="gradient" color="info" disableRipple >{t('submit')}</MDButton>
                                                       
                                                        : null
                                                    }
                           
                                            </Grid>
                                       
                                        </Grid>
                                    </Card>
                                }
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid>
            </MDBox>
            <MDBox>
                {(validationErrors.length > 0)?
                
            <ValidationErrorTable errors={validationErrors} />
        :null}
            </MDBox>
            
        </DashboardLayout>
    )
}
export default BulkUpload;
